import { Box } from '@mui/material'
import { FeaturesFullPage } from './FeaturesFullPage'

export function FeaturesTab() {
  return (
    <Box>
      <FeaturesFullPage />
    </Box>
  )
}
